export enum DocumentTypeSource {
    DATABASE = 'DATABASE',
    /**
     * Valeurs renvoyées par le BFF.
     */
    BFF = 'VIRTUAL',
}

export enum DocumentTypeCode {
    ANALYSE_RISQUE = 'ANALYSE_RISQUE',
    PRISE_EN_CHARGE = 'PRISE_EN_CHARGE',
}

export interface TypeDocumentReglementaire {
    id: number | null;
    code: string;
    libelle: string;
    source: DocumentTypeSource;
}

export const isBffDocumentType = (type: TypeDocumentReglementaire): boolean =>
    type.source === DocumentTypeSource.BFF;

/** @deprecated Utiliser `isBffDocumentType` */
export const isVirtualDocumentType = isBffDocumentType;

export const isAnalyseRisqueDocumentType = (type?: TypeDocumentReglementaire): boolean =>
    type?.code === DocumentTypeCode.ANALYSE_RISQUE;
